import styled from 'styled-components'

export const WrapperColumn = styled.div(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
    margin-bottom: 24px;
    position: relative;

    &:last-of-type {
      margin-bottom: 0;
    }

    @media (min-width: ${theme.media.tablet}) {
      justify-content: flex-start;
    }
  `
)

export const AnchorImage = styled.a(
  ({ theme }) => `
    margin-right: 10px;
    height: 60px;

    @media (min-width: ${theme.media.tablet}) {
      font-size: 19px;
      height: 90px;
    }
  `
)

export const Column = styled.div(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
    width: 100%;
  `
)

export const Image = styled.img(
  ({ theme }) => `
    border: 1px solid ${theme.colors.n400};
    border-radius: 6px;
    height: 60px;
    width: 60px;

    @media (min-width: ${theme.media.tablet}) {
      height: 90px;
      width: 90px;
    }
  `
)

export const InfoWrapper = styled.div(
  ({ theme }) => `
    display: flex;
    flex-direction: row;
    width: 100%;
  `
)

export const BasicInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const Name = styled.a(
  ({ theme }) => `
    color: ${theme.colors.p500};
    font-size: 16px;
    max-width: 85%;

    @media (min-width: ${theme.media.tablet}) {
      font-size: 19px;
      max-width: 90%;
    }
  `
)

export const SmallInfo = styled.span(
  ({ theme }) => `
    color: ${theme.colors.n400};
    font-size: 12px;
    line-height: 16px;
    height: 16px;

    @media (min-width: ${theme.media.tablet}) {
      font-size: 13px;
      height: 20px;
      line-height: 20px;
    }
  `
)

export const RemoveButton = styled.button(
  ({ theme }) => `
    align-items: center;
    background: ${theme.colors.n100};
    border-radius: 15px;
    cursor: pointer;
    display: flex;
    font-size: 10px;
    height: 25px;
    justify-content: center;
    position: absolute;
    right: 0;
    width: 25px;

    & i {
      margin-bottom: 1px;
    }

    &:hover {
      background: ${theme.colors.n200};
    }
    `
)

export const PriceInfoWrapper = styled.div(
  ({ theme }) => `
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    margin-top: 15px;
  `
)

export const Flex = styled.div(
  ({ theme }) => `
    display: flex;
    justify-content: space-between;
    width: 100%;

    @media (min-width: ${theme.media.tablet}) {
      justify-content: flex-start;
    }

    @media (max-width: ${theme.media.mobile.md}) {
      flex-direction: column;
    }
  `
)

export const AlertWrapper = styled.div`
  text-align: left;
`

export const AlertTitle = styled.h1(
  ({ theme }) => `
    color: ${theme.colors.n600};
    font-size: 16px;
    font-weight: ${theme.font.weight.semibold};
    margin-bottom: 20px;
  `
)

export const PriceInfo = styled.div(
  ({ theme }) => `
    display: flex;
    flex-direction: column;

    @media (max-width: ${theme.media.mobile.md}) {
      margin-bottom: 12px;
    }
  `
)

export const UnitPrice = styled.span(
  ({ theme, decoration }) => `
    color: ${theme.colors.n400};
    font-size: 13px;
    height: 20px;
    line-height: 20px;
    text-align: left;
    text-decoration: ${decoration ? 'line-through' : 'unset'};
  `
)

export const TotalPrice = styled.span(
  ({ theme }) => `
    ont-size: 14px;
    height: 20px;
    line-height: 20px;
    font-weight: ${theme.font.weight.semibold};
  `
)

export const ShippingBadgeWrapper = styled.div(
  ({ theme }) => `
    align-items: center;
    color: ${theme.colors.n300}
    display: flex;
    font-size: 13px;
    font-weight: ${theme.font.weight.semibold};
    justify-content: flex-start;
    position: relative;

    & i {
      font-size: 24px;
      margin-top: 3px;
      margin-left: 6px;
    }

    @media (min-width: ${theme.media.tablet}) {
      justify-content: flex-end;
    }
  `
)
